import {
  ALL_SELECT_FILTER_ITEM,
  EXCLUSION_STATUS,
  TASK_DUPLICATE_FILTER,
} from '../../common/constants'

import MENU_CURATION_TASK_NO_ERROR_TAG_FILTER from './menu-curation-task-no-error-tag-filter'
import MENU_CURATION_TASK_SORT_BY from './menu-curation-task-sort-by'

const DEFAULT_MENU_CURATION_TASK_LIST_FILTERS = {
  TASK_STATUS: ALL_SELECT_FILTER_ITEM.value,
  SORT_BY: MENU_CURATION_TASK_SORT_BY.DEFAULT.value,
  AUTOEAT_STATUS: EXCLUSION_STATUS.INCLUDED.value,
  SEARCH: '',
  ASSIGNED_TIER_ONE_CURATOR: ALL_SELECT_FILTER_ITEM.value,
  ASSIGNED_CURATOR: ALL_SELECT_FILTER_ITEM.value,
  ASSIGNED_QA: ALL_SELECT_FILTER_ITEM.value,
  ASSIGNED_QC: ALL_SELECT_FILTER_ITEM.value,
  DUPLICATE: TASK_DUPLICATE_FILTER.NOT_DUPLICATE.value,
  CURATOR_ID: null,
  QA_ID: null,
  TAGS: [MENU_CURATION_TASK_NO_ERROR_TAG_FILTER.value],
  BACKLOG: ALL_SELECT_FILTER_ITEM.value,
}

export default DEFAULT_MENU_CURATION_TASK_LIST_FILTERS
